import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAIL,
} from '../actions/types';

// Get user from localStorage safely
const getInitialUser = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      // Ensure user has required fields
      return {
        id: user.id,
        username: user.username || user.email,
        email: user.email,
        fullName:
          user.fname && user.lname
            ? `${user.fname} ${user.lname}`
            : user.fname || user.lname || user.username || 'User',
        fname: user.fname,
        lname: user.lname,
        avatar: user.avatar,
        role: user.role,
        accessToken: user.accessToken,
        ...user, // Include all other fields
      };
    }
    return null;
  } catch (error) {
    console.error('Error parsing user from localStorage:', error);
    localStorage.removeItem('user'); // Clear corrupted data
    return null;
  }
};

const user = getInitialUser();

const initialState = user
  ? { isLoggedIn: true, user, isLoading: false }
  : { isLoggedIn: false, user: null, isLoading: false };

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        isLoading: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        isLoading: false,
      };
    case LOGIN_SUCCESS:
      // Ensure user data is properly structured
      const loginUser = {
        id: payload.user.id,
        username: payload.user.username || payload.user.email,
        email: payload.user.email,
        fullName:
          payload.user.fname && payload.user.lname
            ? `${payload.user.fname} ${payload.user.lname}`
            : payload.user.fname ||
              payload.user.lname ||
              payload.user.username ||
              'User',
        fname: payload.user.fname,
        lname: payload.user.lname,
        avatar: payload.user.avatar,
        role: payload.user.role,
        accessToken: payload.user.accessToken,
        ...payload.user, // Include all other fields
      };

      return {
        ...state,
        isLoggedIn: true,
        user: loginUser,
        isLoading: false,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        isLoading: false,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        isLoading: false,
      };
    case UPDATE_USER_PROFILE:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_USER_PROFILE_SUCCESS:
      // Ensure updated user data is properly structured
      const updatedUser = {
        id: payload.user.id,
        username: payload.user.username || payload.user.email,
        email: payload.user.email,
        fullName:
          payload.user.fname && payload.user.lname
            ? `${payload.user.fname} ${payload.user.lname}`
            : payload.user.fname ||
              payload.user.lname ||
              payload.user.username ||
              'User',
        fname: payload.user.fname,
        lname: payload.user.lname,
        avatar: payload.user.avatar,
        role: payload.user.role,
        accessToken: payload.user.accessToken,
        ...payload.user, // Include all other fields
      };

      return {
        ...state,
        isLoggedIn: true,
        user: updatedUser,
        isLoading: false,
      };
    case UPDATE_USER_PROFILE_FAIL:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
